import config from '../config'
import CoreServices from './coreServices'
import { MESSAGE } from '../constants/services'
import axios from 'axios'

class MessageServices extends CoreServices {
  async getConversation(receiverId) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      
    }
    try {
      let response = await axios.post(`${this.apiEnpointV1}/conversations`,
        { receiverId: receiverId }, {
        headers: headers
      })
      return await response.data.data
    } catch (error) {
      return { error }
    }
  }

  async getConversationByCallId(callId) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      
    }
    try {
      let response = await axios.post(`${this.apiEnpointV1}/conversations`,
        { callId: callId }, {
        headers: headers
      })
      return await response.data.data
    } catch (error) {
      return { error }
    }
  }

  async readMessages(channel) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      
    }
    try {
      let response = await axios.post(`${this.apiEnpointV1}/conversations/${channel}/read-messages`, {  }, {
        headers: headers
      })
      return await response.data
    } catch (error) {
      return { error }
    }
  }

  async deleteChannel(channel) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      
    }
    try {
      let response = await axios.delete(`${this.apiEnpointV1}/conversations/${channel}`, {
        headers: headers
      })
      return await response.data
    } catch (error) {
      return { error }
    }
  }

  async sendMessage(args) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      
    }
    try {
      let { data } = await axios.post(`${this.apiEnpointV1}/conversations/${args.channel}/messages`,
        args, {
        headers: headers
      })
      return data
    } catch (error) {
      return { error }
    }
  }

  async getUnread() {
    try {
      let { data } = await axios.get(`${this.apiEnpointV1}/conversations/unread`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      })
      return data
    } catch (error) {
      return { error }
    }
  }

  async sendAttach(channel, args) {
    let headers = {
    }
    try {
      let { data } = await axios.post(`${this.apiEnpointV1}/conversations/${channel}/attachs`,
        args, {
        headers: headers
      })
      return data.data
    } catch (error) {
      return { error }
    }
  }

  async getMessages(channel, queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/conversations/${channel}/messages`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        params: queries
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new MessageServices(MESSAGE.BASE)
